<script>
export default {
  name: 'ConfirmarCadastro',
  props: ['token'],
  data: function () {
    return {
    }
  },
  created () {
  },
  methods: {

  }
}
</script>



// WEBPACK FOOTER //
// src/views/ConfirmarCadastro.vue